/** @jsx jsx */
import React from "react"
import { jsx, Themed, Card, Button } from "theme-ui"

import { useCart } from "../cart-state"

const Product = ({ product }) => {
  const { id, name, description, price } = product
  const { addToCart, removeFromCart, increment, decrement, cart } = useCart()
  const howMany = id =>
    cart[cart.findIndex(inCart => inCart.id === id)]?.quantity
  return (
    <Card sx={{ mb: 3 }}>
      <div sx={{ display: "flex", alignItems: "start" }}>
        <div sx={{ flex: 1 }}>
          <Themed.h4 sx={{ my: 0 }}>{name}</Themed.h4>
          <Themed.p sx={{ mt: 0 }}>{description}</Themed.p>
        </div>
        <Themed.p sx={{ mt: 0, fontWeight: "bold" }}>${price}</Themed.p>
      </div>
      <div
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {howMany(id) ? (
          <React.Fragment>
            <Button
              variant="qty-picker"
              onClick={
                howMany(id) === 1
                  ? () => removeFromCart({ id })
                  : () => decrement({ id })
              }
            >
              -
            </Button>
            <Themed.p sx={{ my: 0 }}>Llevas {howMany(id)}</Themed.p>
            <Button variant="qty-picker" onClick={() => increment({ id })}>
              +
            </Button>
          </React.Fragment>
        ) : (
          <Button
            variant="product"
            onClick={() =>
              addToCart({ id, name, description, price, quantity: 1 })
            }
          >
            Agregar al pedido
          </Button>
        )}
      </div>
    </Card>
  )
}

export default Product
